import Button from "components/Button/index";
import Drawer from "components/Drawer/index";
import Modal from "components/Models/index";
import UserModal from "components/UserFormModal/index";
import useScreenMobile from "hooks/useScreen";
import React, { useEffect } from "react";
import editLight from "assets/images/manageTeam/editLight.svg";
import editDark from "assets/images/manageTeam/editDark.svg";
import deleteLight from "assets/images/manageTeam/deleteLight.svg";
import deleteDark from "assets/images/manageTeam/deleteDark.svg";
import "./manageUserList.scss";
import useTheme from "hooks/observer";

function ManageUserListContent({
  userList = [],
  csvList = [],
  validate,
  deleteUser,
  editUser,
  setShowUserList,
  setEditModal,
  setUserIndex,
  listName,
  reuploadHandler,
  addToAccountHandler,
  hasErrors = false,
  editModal = false,
  editableUser,
  setEditableUser,
  multipleUserEditSubmit,
  setUserList,
  isMobile = false
}) {
  const theme = useTheme();
  const editIcon = theme === "light" ? editLight : editDark;
  const deleteIcon = theme === "light" ? deleteLight : deleteDark;

  useEffect(() => {
    
  }, [editModal]);

  const handleEditUser = (index) => {
    editUser(index);
    setEditModal(true);
    setUserIndex(index);
  };

  const handleDeleteUser = (index) => {
    deleteUser(index);
  };

  return (
    <div className="manageUserList">
      <div className="manageUserListContainer">
        <div className="manageUserListBox">
          <div className="commonHeading">
            <h1>Users List</h1>
            <p>The users list has been successfully imported.</p>
          </div>
          {isMobile ? (
            <div className="manageUserListMobile">
              <div className="manageUserListMobileTitle">
                <p>User Details</p>
              </div>
              <div className="manageUserListMobileDetails">
                {csvList.map((item, index) => (
                  <div
                    key={item.id || index}
                    className="manageUserListMobileDetailsItem"
                  >
                    <div className="content">
                      <div className="text">
                        <h1>{item.name}</h1>
                        <div
                          className={
                            validate(item.name, item.email) === "Success"
                              ? "success"
                              : "error"
                          }
                        >
                          {" "}
                          <p>{validate(item.name, item.email)}</p>
                        </div>
                      </div>
                      <p>{item.email}</p>
                    </div>
                    <div className="Icons">
                      <img
                        src={editIcon}
                        alt="Edit user"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditUser(index);
                        }}
                      />
                      <img
                        src={deleteIcon}
                        alt="Delete user"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteUser(index)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="manageUserListBoxTableContainer">
              <div className="tableWrap">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="name">Name</th>
                      <th className="email">Email</th>
                      <th className="status">Status</th>
                      <th className="modify"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {csvList.map((item, index) => (
                      <tr
                        key={item.id || index}
                        className={
                          validate(item.name, item.email) !== "Success"
                            ? "invalid"
                            : ""
                        }
                      >
                        <td className="name">{item.name}</td>
                        <td className="email">{item.email}</td>
                        <td className="status data">
                          <p
                            className={
                              validate(item.name, item.email) === "Success"
                                ? "success"
                                : "error"
                            }
                          >
                            {validate(item.name, item.email)}
                          </p>
                        </td>
                        <td className="modify modifyTd">
                          <div className="iconsWrapper">
                            <img
                              src={editIcon}
                              alt="Edit user"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEditUser(index)}
                            />
                            <img
                              src={deleteIcon}
                              alt="Delete user"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteUser(index)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {hasErrors && (
            <p className="hasError">
              The table has some errors. Please fix or delete them to continue.
            </p>
          )}
          <div className="userListBoxButtonsWrapper">
            <Button
              type="white"
              title={
                listName === "singleUser"
                  ? "Add More User"
                  : "Re-upload user list"
              }
              onClick={reuploadHandler}
            />
            <Button
              type="violet"
              title="Add to Account"
              onClick={addToAccountHandler}
              disabled={hasErrors || !csvList.length}
            />
          </div>
        </div>
        {editModal && (
          <UserModal
            title="Edit User"
            description="Please update the user details as needed."
            setShowUserList={setShowUserList}
            formData={editableUser}
            setFormData={setEditableUser}
            setShowModal={setEditModal}
            onSubmit={multipleUserEditSubmit}
            btnText="Update"
            setUserlist={setUserList}
            userlist={userList}
            init={false}
          />
        )}
      </div>
    </div>
  );
}

function ManageUserList(props) {
  const isMobile = useScreenMobile({ size: 992 });
  const { setShowUserList } = props;
  return (
    <>
      {isMobile ? (
        <Drawer
          showFooter={false}
          isVisible={true}
          handleCancel={() => setShowUserList(false)}
        >
          <ManageUserListContent {...props} isMobile={isMobile} />
        </Drawer>
      ) : (
        <Modal
          showFooter={false}
          mockClass={"manageUsers"}
          handleCancel={() => setShowUserList(false)}
        >
          <ManageUserListContent {...props} isMobile={isMobile} />
        </Modal>
      )}
    </>
  );
}

export default ManageUserList;
